"use strict";

var _regeneratorRuntime = require("/app/front/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/app/front/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/app/front/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/app/front/node_modules/@babel/runtime/helpers/createClass.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Explorer_1 = __importDefault(require("../../Actions/Explorer"));

var ApiError_1 = __importDefault(require("../../Errors/ApiError"));

function buildDataOptions(options, data) {
  var _a;

  var dataFields = {};

  var _iterator = _createForOfIteratorHelper(data),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var row = _step.value;
      var dataType = (_a = row.type) !== null && _a !== void 0 ? _a : 'data';

      if (typeof row.value === 'number') {
        dataFields[dataType + ':number.' + row.key] = String(row.value);
      } else if (typeof row.value === 'boolean') {
        dataFields[dataType + ':bool.' + row.key] = row.value ? 'true' : 'false';
      } else {
        dataFields[dataType + '.' + row.key] = row.value;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return Object.assign({}, options, dataFields);
}

var ExplorerApi = /*#__PURE__*/function () {
  function ExplorerApi(endpoint, namespace, args) {
    var _this = this;

    _classCallCheck(this, ExplorerApi);

    this.endpoint = endpoint;
    this.namespace = namespace;

    if (args.fetch) {
      this.fetchBuiltin = args.fetch;
    } else {
      this.fetchBuiltin = window.fetch;
    }

    this.action = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = Explorer_1.default;
              _context.next = 3;
              return _this.getConfig();

            case 3:
              _context.t1 = _context.sent.contract;
              _context.t2 = _this;
              return _context.abrupt("return", new _context.t0(_context.t1, _context.t2));

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }

  _createClass(ExplorerApi, [{
    key: "getConfig",
    value: function () {
      var _getConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.fetchEndpoint('/v1/config', {});

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getConfig() {
        return _getConfig.apply(this, arguments);
      }

      return getConfig;
    }()
  }, {
    key: "getAssets",
    value: function () {
      var _getAssets = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var options,
            page,
            limit,
            data,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                options = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                page = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 1;
                limit = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : 100;
                data = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : [];
                _context3.next = 6;
                return this.fetchEndpoint('/v1/assets', Object.assign({
                  page: page,
                  limit: limit
                }, buildDataOptions(options, data)));

              case 6:
                return _context3.abrupt("return", _context3.sent);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAssets() {
        return _getAssets.apply(this, arguments);
      }

      return getAssets;
    }()
  }, {
    key: "countAssets",
    value: function () {
      var _countAssets = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(options) {
        var data,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : [];
                _context4.next = 3;
                return this.countEndpoint('/v1/assets', buildDataOptions(options, data));

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function countAssets(_x) {
        return _countAssets.apply(this, arguments);
      }

      return countAssets;
    }()
  }, {
    key: "getAsset",
    value: function () {
      var _getAsset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.fetchEndpoint('/v1/assets/' + id, {});

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getAsset(_x2) {
        return _getAsset.apply(this, arguments);
      }

      return getAsset;
    }()
  }, {
    key: "getAssetStats",
    value: function () {
      var _getAssetStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.fetchEndpoint('/v1/assets/' + id + '/stats', {});

              case 2:
                return _context6.abrupt("return", _context6.sent);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getAssetStats(_x3) {
        return _getAssetStats.apply(this, arguments);
      }

      return getAssetStats;
    }()
  }, {
    key: "getAssetLogs",
    value: function () {
      var _getAssetLogs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id) {
        var page,
            limit,
            order,
            _args7 = arguments;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                page = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : 1;
                limit = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : 100;
                order = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : 'desc';
                _context7.next = 5;
                return this.fetchEndpoint('/v1/assets/' + id + '/logs', {
                  page: page,
                  limit: limit,
                  order: order
                });

              case 5:
                return _context7.abrupt("return", _context7.sent);

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getAssetLogs(_x4) {
        return _getAssetLogs.apply(this, arguments);
      }

      return getAssetLogs;
    }()
  }, {
    key: "getCollections",
    value: function () {
      var _getCollections = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var options,
            page,
            limit,
            _args8 = arguments;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                options = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
                page = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : 1;
                limit = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : 100;
                _context8.next = 5;
                return this.fetchEndpoint('/v1/collections', Object.assign({
                  page: page,
                  limit: limit
                }, options));

              case 5:
                return _context8.abrupt("return", _context8.sent);

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getCollections() {
        return _getCollections.apply(this, arguments);
      }

      return getCollections;
    }()
  }, {
    key: "countCollections",
    value: function () {
      var _countCollections = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var options,
            _args9 = arguments;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                options = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};
                _context9.next = 3;
                return this.countEndpoint('/v1/collections', options);

              case 3:
                return _context9.abrupt("return", _context9.sent);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function countCollections() {
        return _countCollections.apply(this, arguments);
      }

      return countCollections;
    }()
  }, {
    key: "getCollection",
    value: function () {
      var _getCollection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(name) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.fetchEndpoint('/v1/collections/' + name, {});

              case 2:
                return _context10.abrupt("return", _context10.sent);

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getCollection(_x5) {
        return _getCollection.apply(this, arguments);
      }

      return getCollection;
    }()
  }, {
    key: "getCollectionStats",
    value: function () {
      var _getCollectionStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(name) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.fetchEndpoint('/v1/collections/' + name + '/stats', {});

              case 2:
                return _context11.abrupt("return", _context11.sent);

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getCollectionStats(_x6) {
        return _getCollectionStats.apply(this, arguments);
      }

      return getCollectionStats;
    }()
  }, {
    key: "getCollectionLogs",
    value: function () {
      var _getCollectionLogs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(name) {
        var page,
            limit,
            order,
            _args12 = arguments;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                page = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : 1;
                limit = _args12.length > 2 && _args12[2] !== undefined ? _args12[2] : 100;
                order = _args12.length > 3 && _args12[3] !== undefined ? _args12[3] : 'desc';
                _context12.next = 5;
                return this.fetchEndpoint('/v1/collections/' + name + '/logs', {
                  page: page,
                  limit: limit,
                  order: order
                });

              case 5:
                return _context12.abrupt("return", _context12.sent);

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getCollectionLogs(_x7) {
        return _getCollectionLogs.apply(this, arguments);
      }

      return getCollectionLogs;
    }()
  }, {
    key: "getSchemas",
    value: function () {
      var _getSchemas = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var options,
            page,
            limit,
            _args13 = arguments;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                options = _args13.length > 0 && _args13[0] !== undefined ? _args13[0] : {};
                page = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : 1;
                limit = _args13.length > 2 && _args13[2] !== undefined ? _args13[2] : 100;
                _context13.next = 5;
                return this.fetchEndpoint('/v1/schemas', Object.assign({
                  page: page,
                  limit: limit
                }, options));

              case 5:
                return _context13.abrupt("return", _context13.sent);

              case 6:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getSchemas() {
        return _getSchemas.apply(this, arguments);
      }

      return getSchemas;
    }()
  }, {
    key: "countSchemas",
    value: function () {
      var _countSchemas = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var options,
            _args14 = arguments;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                options = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : {};
                _context14.next = 3;
                return this.countEndpoint('/v1/schemas', options);

              case 3:
                return _context14.abrupt("return", _context14.sent);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function countSchemas() {
        return _countSchemas.apply(this, arguments);
      }

      return countSchemas;
    }()
  }, {
    key: "getSchema",
    value: function () {
      var _getSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(collection, name) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.fetchEndpoint('/v1/schemas/' + collection + '/' + name, {});

              case 2:
                return _context15.abrupt("return", _context15.sent);

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function getSchema(_x8, _x9) {
        return _getSchema.apply(this, arguments);
      }

      return getSchema;
    }()
  }, {
    key: "getSchemaStats",
    value: function () {
      var _getSchemaStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(collection, name) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.fetchEndpoint('/v1/schemas/' + collection + '/' + name + '/stats', {});

              case 2:
                return _context16.abrupt("return", _context16.sent);

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function getSchemaStats(_x10, _x11) {
        return _getSchemaStats.apply(this, arguments);
      }

      return getSchemaStats;
    }()
  }, {
    key: "getSchemaLogs",
    value: function () {
      var _getSchemaLogs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(collection, name) {
        var page,
            limit,
            order,
            _args17 = arguments;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                page = _args17.length > 2 && _args17[2] !== undefined ? _args17[2] : 1;
                limit = _args17.length > 3 && _args17[3] !== undefined ? _args17[3] : 100;
                order = _args17.length > 4 && _args17[4] !== undefined ? _args17[4] : 'desc';
                _context17.next = 5;
                return this.fetchEndpoint('/v1/schemas/' + collection + '/' + name + '/logs', {
                  page: page,
                  limit: limit,
                  order: order
                });

              case 5:
                return _context17.abrupt("return", _context17.sent);

              case 6:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function getSchemaLogs(_x12, _x13) {
        return _getSchemaLogs.apply(this, arguments);
      }

      return getSchemaLogs;
    }()
  }, {
    key: "getTemplates",
    value: function () {
      var _getTemplates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var options,
            page,
            limit,
            data,
            _args18 = arguments;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                options = _args18.length > 0 && _args18[0] !== undefined ? _args18[0] : {};
                page = _args18.length > 1 && _args18[1] !== undefined ? _args18[1] : 1;
                limit = _args18.length > 2 && _args18[2] !== undefined ? _args18[2] : 100;
                data = _args18.length > 3 && _args18[3] !== undefined ? _args18[3] : [];
                _context18.next = 6;
                return this.fetchEndpoint('/v1/templates', Object.assign({
                  page: page,
                  limit: limit
                }, buildDataOptions(options, data)));

              case 6:
                return _context18.abrupt("return", _context18.sent);

              case 7:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function getTemplates() {
        return _getTemplates.apply(this, arguments);
      }

      return getTemplates;
    }()
  }, {
    key: "countTemplates",
    value: function () {
      var _countTemplates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var options,
            data,
            _args19 = arguments;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                options = _args19.length > 0 && _args19[0] !== undefined ? _args19[0] : {};
                data = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : [];
                _context19.next = 4;
                return this.countEndpoint('/v1/templates', buildDataOptions(options, data));

              case 4:
                return _context19.abrupt("return", _context19.sent);

              case 5:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function countTemplates() {
        return _countTemplates.apply(this, arguments);
      }

      return countTemplates;
    }()
  }, {
    key: "getTemplate",
    value: function () {
      var _getTemplate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(collection, id) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return this.fetchEndpoint('/v1/templates/' + collection + '/' + id, {});

              case 2:
                return _context20.abrupt("return", _context20.sent);

              case 3:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function getTemplate(_x14, _x15) {
        return _getTemplate.apply(this, arguments);
      }

      return getTemplate;
    }()
  }, {
    key: "getTemplateStats",
    value: function () {
      var _getTemplateStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(collection, name) {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return this.fetchEndpoint('/v1/templates/' + collection + '/' + name + '/stats', {});

              case 2:
                return _context21.abrupt("return", _context21.sent);

              case 3:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function getTemplateStats(_x16, _x17) {
        return _getTemplateStats.apply(this, arguments);
      }

      return getTemplateStats;
    }()
  }, {
    key: "getTemplateLogs",
    value: function () {
      var _getTemplateLogs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(collection, id) {
        var page,
            limit,
            order,
            _args22 = arguments;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                page = _args22.length > 2 && _args22[2] !== undefined ? _args22[2] : 1;
                limit = _args22.length > 3 && _args22[3] !== undefined ? _args22[3] : 100;
                order = _args22.length > 4 && _args22[4] !== undefined ? _args22[4] : 'desc';
                _context22.next = 5;
                return this.fetchEndpoint('/v1/templates/' + collection + '/' + id + '/logs', {
                  page: page,
                  limit: limit,
                  order: order
                });

              case 5:
                return _context22.abrupt("return", _context22.sent);

              case 6:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function getTemplateLogs(_x18, _x19) {
        return _getTemplateLogs.apply(this, arguments);
      }

      return getTemplateLogs;
    }()
  }, {
    key: "getTransfers",
    value: function () {
      var _getTransfers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        var options,
            page,
            limit,
            _args23 = arguments;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                options = _args23.length > 0 && _args23[0] !== undefined ? _args23[0] : {};
                page = _args23.length > 1 && _args23[1] !== undefined ? _args23[1] : 1;
                limit = _args23.length > 2 && _args23[2] !== undefined ? _args23[2] : 100;
                _context23.next = 5;
                return this.fetchEndpoint('/v1/transfers', Object.assign({
                  page: page,
                  limit: limit
                }, options));

              case 5:
                return _context23.abrupt("return", _context23.sent);

              case 6:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function getTransfers() {
        return _getTransfers.apply(this, arguments);
      }

      return getTransfers;
    }()
  }, {
    key: "countTransfers",
    value: function () {
      var _countTransfers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        var options,
            _args24 = arguments;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                options = _args24.length > 0 && _args24[0] !== undefined ? _args24[0] : {};
                _context24.next = 3;
                return this.countEndpoint('/v1/transfers', options);

              case 3:
                return _context24.abrupt("return", _context24.sent);

              case 4:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function countTransfers() {
        return _countTransfers.apply(this, arguments);
      }

      return countTransfers;
    }()
  }, {
    key: "getOffers",
    value: function () {
      var _getOffers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
        var options,
            page,
            limit,
            _args25 = arguments;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                options = _args25.length > 0 && _args25[0] !== undefined ? _args25[0] : {};
                page = _args25.length > 1 && _args25[1] !== undefined ? _args25[1] : 1;
                limit = _args25.length > 2 && _args25[2] !== undefined ? _args25[2] : 100;
                _context25.next = 5;
                return this.fetchEndpoint('/v1/offers', Object.assign({
                  page: page,
                  limit: limit
                }, options));

              case 5:
                return _context25.abrupt("return", _context25.sent);

              case 6:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function getOffers() {
        return _getOffers.apply(this, arguments);
      }

      return getOffers;
    }()
  }, {
    key: "countOffers",
    value: function () {
      var _countOffers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        var options,
            _args26 = arguments;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                options = _args26.length > 0 && _args26[0] !== undefined ? _args26[0] : {};
                _context26.next = 3;
                return this.countEndpoint('/v1/offers', options);

              case 3:
                return _context26.abrupt("return", _context26.sent);

              case 4:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function countOffers() {
        return _countOffers.apply(this, arguments);
      }

      return countOffers;
    }()
  }, {
    key: "getOffer",
    value: function () {
      var _getOffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(id) {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.next = 2;
                return this.fetchEndpoint('/v1/offers/' + id, {});

              case 2:
                return _context27.abrupt("return", _context27.sent);

              case 3:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function getOffer(_x20) {
        return _getOffer.apply(this, arguments);
      }

      return getOffer;
    }()
  }, {
    key: "getAccounts",
    value: function () {
      var _getAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
        var options,
            page,
            limit,
            _args28 = arguments;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                options = _args28.length > 0 && _args28[0] !== undefined ? _args28[0] : {};
                page = _args28.length > 1 && _args28[1] !== undefined ? _args28[1] : 1;
                limit = _args28.length > 2 && _args28[2] !== undefined ? _args28[2] : 100;
                _context28.next = 5;
                return this.fetchEndpoint('/v1/accounts', Object.assign({
                  page: page,
                  limit: limit
                }, options));

              case 5:
                return _context28.abrupt("return", _context28.sent);

              case 6:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function getAccounts() {
        return _getAccounts.apply(this, arguments);
      }

      return getAccounts;
    }()
  }, {
    key: "getBurns",
    value: function () {
      var _getBurns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
        var options,
            page,
            limit,
            _args29 = arguments;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                options = _args29.length > 0 && _args29[0] !== undefined ? _args29[0] : {};
                page = _args29.length > 1 && _args29[1] !== undefined ? _args29[1] : 1;
                limit = _args29.length > 2 && _args29[2] !== undefined ? _args29[2] : 100;
                _context29.next = 5;
                return this.fetchEndpoint('/v1/burns', Object.assign({
                  page: page,
                  limit: limit
                }, options));

              case 5:
                return _context29.abrupt("return", _context29.sent);

              case 6:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function getBurns() {
        return _getBurns.apply(this, arguments);
      }

      return getBurns;
    }()
  }, {
    key: "countAccounts",
    value: function () {
      var _countAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
        var options,
            _args30 = arguments;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                options = _args30.length > 0 && _args30[0] !== undefined ? _args30[0] : {};
                _context30.next = 3;
                return this.countEndpoint('/v1/accounts', options);

              case 3:
                return _context30.abrupt("return", _context30.sent);

              case 4:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function countAccounts() {
        return _countAccounts.apply(this, arguments);
      }

      return countAccounts;
    }()
  }, {
    key: "getAccount",
    value: function () {
      var _getAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(account) {
        var options,
            _args31 = arguments;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                options = _args31.length > 1 && _args31[1] !== undefined ? _args31[1] : {};
                _context31.next = 3;
                return this.fetchEndpoint('/v1/accounts/' + account, options);

              case 3:
                return _context31.abrupt("return", _context31.sent);

              case 4:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function getAccount(_x21) {
        return _getAccount.apply(this, arguments);
      }

      return getAccount;
    }()
  }, {
    key: "getAccountCollection",
    value: function () {
      var _getAccountCollection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(account, collection) {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.next = 2;
                return this.fetchEndpoint('/v1/accounts/' + account + '/' + collection, {});

              case 2:
                return _context32.abrupt("return", _context32.sent);

              case 3:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this);
      }));

      function getAccountCollection(_x22, _x23) {
        return _getAccountCollection.apply(this, arguments);
      }

      return getAccountCollection;
    }()
  }, {
    key: "getAccountBurns",
    value: function () {
      var _getAccountBurns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(account) {
        var options,
            _args33 = arguments;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                options = _args33.length > 1 && _args33[1] !== undefined ? _args33[1] : {};
                _context33.next = 3;
                return this.fetchEndpoint('/v1/burns/' + account, options);

              case 3:
                return _context33.abrupt("return", _context33.sent);

              case 4:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this);
      }));

      function getAccountBurns(_x24) {
        return _getAccountBurns.apply(this, arguments);
      }

      return getAccountBurns;
    }()
  }, {
    key: "fetchEndpoint",
    value: function () {
      var _fetchEndpoint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(path, args) {
        var response, json, f, queryString;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                f = this.fetchBuiltin;
                queryString = Object.keys(args).map(function (key) {
                  var value = args[key];

                  if (value === true) {
                    value = 'true';
                  }

                  if (value === false) {
                    value = 'false';
                  }

                  return key + '=' + encodeURIComponent(value);
                }).join('&');
                _context34.prev = 2;
                _context34.next = 5;
                return f(this.endpoint + '/' + this.namespace + path + (queryString.length > 0 ? '?' + queryString : ''));

              case 5:
                response = _context34.sent;
                _context34.next = 8;
                return response.json();

              case 8:
                json = _context34.sent;
                _context34.next = 14;
                break;

              case 11:
                _context34.prev = 11;
                _context34.t0 = _context34["catch"](2);
                throw new ApiError_1.default(_context34.t0.message, 500);

              case 14:
                if (!(response.status !== 200)) {
                  _context34.next = 16;
                  break;
                }

                throw new ApiError_1.default(json.message, response.status);

              case 16:
                if (json.success) {
                  _context34.next = 18;
                  break;
                }

                throw new ApiError_1.default(json.message, response.status);

              case 18:
                return _context34.abrupt("return", json.data);

              case 19:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this, [[2, 11]]);
      }));

      function fetchEndpoint(_x25, _x26) {
        return _fetchEndpoint.apply(this, arguments);
      }

      return fetchEndpoint;
    }()
  }, {
    key: "countEndpoint",
    value: function () {
      var _countEndpoint = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(path, args) {
        var res;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.next = 2;
                return this.fetchEndpoint(path + '/_count', args);

              case 2:
                res = _context35.sent;
                return _context35.abrupt("return", parseInt(res, 10));

              case 4:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function countEndpoint(_x27, _x28) {
        return _countEndpoint.apply(this, arguments);
      }

      return countEndpoint;
    }()
  }]);

  return ExplorerApi;
}();

exports.default = ExplorerApi;